import React from 'react';
import {
  Button,
  IconButton,
  Tooltip,
  Box,
  Typography
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  variant?: 'button' | 'icon';
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'inherit' | 'default';
  showHomeButton?: boolean;
  backPath?: string;
  label?: string;
  onClick?: () => void;
  sx?: any;
}

const BackButton: React.FC<BackButtonProps> = ({
  variant = 'button',
  size = 'medium',
  color = 'primary',
  showHomeButton = false,
  backPath,
  label = '返回',
  onClick,
  sx
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onClick) {
      onClick();
    } else if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  if (variant === 'icon') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
        <Tooltip title={label}>
          <IconButton
            onClick={handleBackClick}
            color={color}
            size={size}
            sx={{
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>

        {showHomeButton && (
          <Tooltip title="返回主頁">
            <IconButton
              onClick={handleHomeClick}
              color={color}
              size={size}
              sx={{
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }}
            >
              <HomeIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={handleBackClick}
        size={size}
        //color={color}
        sx={{
          borderRadius: 2,
          textTransform: 'none',
          fontWeight: 500
        }}
      >
        {label}
      </Button>

      {showHomeButton && (
        <Button
          variant="outlined"
          startIcon={<HomeIcon />}
          onClick={handleHomeClick}
          size={size}
          //color={color}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          主頁
        </Button>
      )}
    </Box>
  );
};

export default BackButton;